module.exports = __webpack_public_path__ + "static/media/icon_move.d4e51c7f.svg";